@if (mission) {
  <div class="options">
    <div>
      <button><img src="assets/images/back-icon.svg" (click)="backToMissionConfig()"/></button>
    </div>
    <div>
      <button><img [src]="getMaterialStatusIcon()" (click)="toggleMaterialStatus()"/></button>
    </div>
    <div></div>
  </div>
}

<div class="content">

  <div class="card">
    <div class="row header">
      <a>{{ 'MATERIAL.SKID.LABEL' | translate }}</a>
    </div>
    @for (missionSkid of missionSkids; track missionSkid) {
      <div class="missionSkid">
        <div class="equipments">
          @if (missionSkid.skid.hasPump) {
            <img src="assets/images/pump.png"/>
          }
          @if (missionSkid.skid.hasFlowmeter) {
            <img src="assets/images/flowmeter.png"/>
          }
          @if (missionSkid.skid.hasGateway) {
            <img src="assets/images/gateway.jpeg"/>
          }
        </div>
        <div class="skid">
          {{ missionSkid.skid.skidName }}
        </div>
        <div class="info">
          <div>
            <a class="label">{{ 'MISSION_SKID.PUMP' | translate }}</a>
            <a>{{ missionSkid.pumpName }}</a>
          </div>
          <div>
            <a class="label">{{ 'MISSION_SKID.GATEWAY' | translate }}</a>
            <a>{{ missionSkid.gatewayName }}</a>
          </div>
          <div>
            <a class="label">{{ 'MISSION_SKID.FLOWMETER' | translate }}</a>
            <a>{{ missionSkid.flowmeterName }}</a>
          </div>
          <div>
            <a class="label">{{ missionSkid.skid.exatmregulation }}</a>
            <a>{{ missionSkid.skid.exatmclasse }}</a>
          </div>
          <div>
            <a class="label">{{ 'MATERIAL.LAST_UPDATE' | translate }}</a>
            <a>{{ missionSkid.lastUpdatedOn | timestampToDate | async }} {{ missionSkid.lastUpdatedBy }}</a>
          </div>
        </div>
        @if (!isMaterialComplete()) {
          <div class="controls">
            <!-- <img src="assets/images/edit-icon.svg" (click)="openAddSkidModal(missionSkid)"/> -->
            <img src="assets/images/trash-icon.svg" (click)="removeMissionSkid(missionSkid)"/>
          </div>
        }
      </div>
    }
    @if (missionSkids.length < 1 && !isMaterialComplete()) {
      <div class="row">
        <button><img src="assets/images/add-button.svg" (click)="openAddSkidModal()"/></button>
      </div>
    }
  </div>

  <div class="card">
    <div class="row header">
      <a>{{ 'MATERIAL.ANALYZER.LABEL' | translate }}</a>
    </div>
    <div class="missionAnalyzer">
      @if (missionAnalyzer) {
        <div class="row">
          @if (!(missionAnalyzer.analyzer.isNoAnalyzer)) {
            <img src="assets/images/analyzer.png"/>
          }
          @if (missionAnalyzer.hasGateway) {
            <img src="assets/images/gateway.jpeg"/>
          }
        </div>
        <div class="title">
          @if (missionAnalyzer) {
            <a>{{ missionAnalyzer.analyzerId }}</a>
          }
        </div>
        @if (mission.siteWellawareId != null) {
          <div class="row">
            <a class="label">{{ 'MATERIAL.SITEWELLAWAREID' | translate }}</a>
            <a>{{ mission.siteWellawareId }}</a>
          </div>
        }
        <div class="row">
          <a class="label">{{ 'MATERIAL.ANALYZER.MODEL' | translate }}</a>
          <a>{{ missionAnalyzer.analyzer.analyzermodelName }}</a>
        </div>
        @if (missionAnalyzer.handleFlyingH2) {
          <div class="row">
            <a class="label">{{ 'MATERIAL.ANALYZER.OPTIONS' | translate }}</a>
            <a>{{ 'MATERIAL.ANALYZER.FLYING_H2' | translate }}</a>
          </div>
        }
        <div class="row">
          <a class="label">{{ missionAnalyzer.analyzer.exatmregulation }}</a>
          <a>{{ missionAnalyzer.analyzer.exatmclasse }}</a>
        </div>
        <div class="row">
          <a class="label">{{ 'MATERIAL.TELEMETRY' | translate }}</a>
          <a>{{ missionAnalyzer.analyzer.telemetrysuppliername }}</a>
        </div>
        <div class="row">
          <a class="label">{{ 'MATERIAL.LAST_UPDATE' | translate }}</a>
          <a>{{ missionAnalyzer.lastUpdatedOn | timestampToDate | async }} {{ missionAnalyzer.lastUpdatedBy }}</a>
        </div>
      }
      @if (missionAnalyzer && !isMaterialComplete()) {
        <div class="controls">
          @if (missionAnalyzer) {
            <img src="assets/images/trash-icon.svg" (click)="removeAnalyzer()"/>
          }
        </div>
      }
      @if (!missionAnalyzer && !isMaterialComplete()) {
        <div class="row">
          <button><img src="assets/images/add-button.svg" (click)="openAnalyzerModal()"/></button>
        </div>
      }
    </div>
  </div>

</div>

@if (addingSkid) {
  <app-add-skid
    [mission]="mission"
    [missionSkid]="missionSkidToUpdate"
    (closeModal)="closeAddSkidModal($event)">
  </app-add-skid>
}

@if (addingAnalyzer) {
  <app-add-analyzer
    [mission]="mission"
    [missionAnalyzer]="missionAnalyzer"
    (closeModal)="closeAnalyzerModal($event)">
  </app-add-analyzer>
}

@if (validatingMaterial) {
  <app-material-validation
    [mission]="mission"
    [missionSkids]="missionSkids"
    [missionAnalyzer]="missionAnalyzer"
    (closeModal)="closeMaterialValidation($event)">
  </app-material-validation>
}